import {db, elasticQuery, ELASTIC_SEARCH_CP_REQUESTS_INDEX} from "../../firebase";

const Requests = db.collection('CpRequests');

export const addRequest = data => Requests.add(data)

export const setAsSeen = (IDs) => {
    IDs.forEach(el => {
        Requests.doc(el).update({seen: true});
    });
}
export const updateRequestData = (docId, data) => Requests.doc(docId).update(data)

export const getRequests = (start, size, { must, should }, sortBy) => {

    let obj = {
        model: ELASTIC_SEARCH_CP_REQUESTS_INDEX,
        body: {
            sort: {
                created_date: sortBy || 'desc'
            },
            query: {
                bool: {}
            }
        }
    };

    if(start !== null && size !== null){
        obj.body.from = start * size
        obj.body.size = size
    }
    if(must) {
        obj.body.query.bool.must = must;
    }
    if(should) {
        obj.body.query.bool.should = should;
    }

    return elasticQuery(obj)
}

export const getRequest = (docId) => Requests.doc(docId)

export const getPendingRequests = (query) => {
    let obj = {
        model: ELASTIC_SEARCH_CP_REQUESTS_INDEX,
        body: query
    }

    return elasticQuery(obj)
}

export const getActualAcceptedRequests = (query) => {
    let obj = {
        model: ELASTIC_SEARCH_CP_REQUESTS_INDEX,
        body: query
    }

    return elasticQuery(obj)
}